import { ScaffoldPage } from '@/components/layout/ScaffoldPage'
import { buildBreadcrumbs } from '@/config/routes'

export default function Channels() {
  return (
    <ScaffoldPage
      title="Channel Connections"
      description="Connect Personic AI to your communication channels for real-time intelligence."
      breadcrumbs={buildBreadcrumbs('/settings/integrations/channels')}
      plannedFeatures={[
        'Live chat platform integrations (Intercom, Zendesk, Drift)',
        'Voice platform connections (Twilio, Amazon Connect)',
        'Email channel configuration',
        'Custom channel API for proprietary platforms',
      ]}
      relatedPages={[
        { label: 'Webhooks', href: '/settings/integrations/webhooks' },
        { label: 'Third-Party Integrations', href: '/settings/integrations/third-party' },
      ]}
    />
  )
}
